import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { UnauthenticatedPageComponent } from '@crowdctrl/shared';
import { IonButton, IonIcon } from '@ionic/angular/standalone';
import { addIcons } from 'ionicons';
import { chevronForward } from 'ionicons/icons';

addIcons({ chevronForward });

@Component({
  selector: 'app-unauthorized',
  imports: [UnauthenticatedPageComponent, IonButton, IonIcon],
  templateUrl: './unauthorized.component.html',
  styleUrl: './unauthorized.component.css',
})
export class UnauthorizedComponent {
  constructor(private router: Router) {}

  goToLogin(): void {
    this.router.navigate(['/login']);
  }
}
